var SetOperatorNode = require("../elements/nodes/SetOperatorNode");
var OwlThing = require("../elements/nodes/implementations/OwlThing");
var OwlNothing = require("../elements/nodes/implementations/OwlNothing");
var elementTools = require("../util/elementTools")();

module.exports = function () {

	var statistics = {},
		nodeCount,
		occurencesOfClassAndDatatypeTypes = {},
		edgeCount,
		occurencesOfPropertyTypes = {},
		//Классы в статистике (всего, их IRI, из из внешние)
		classCount,
		classes,
		externalClasses,
		//Классы указанные как эквиваленты
		equivalentsClassCount,
		equivalentsClasses,
		//Классы - типы данных
		datatypeCount,
		datatypes,
		//Свойства с данными
		datatypePropertyCount,
		datatypeProperties,
		//Объектные свойств
		objectPropertyCount,
		objectProperties,
		propertyCount,
		totalIndividualCount,
		filteredNodes,
		filteredProperties,
		totalSubClasses,
		typesCount,
		externalNodeCount,
		//Массив расчётных значений статистики см. в xxxxHelper метод updateStatistic
		calcCount;


	statistics.filter = function (classesAndDatatypes, properties) {
		resetStoredData();
		
		storeTotalCounts(classesAndDatatypes, properties);
		storeClassAndDatatypeCount(classesAndDatatypes);
		storePropertyCount(properties);

		storeOccurencesOfTypes(classesAndDatatypes, occurencesOfClassAndDatatypeTypes);
		storeOccurencesOfTypes(properties, occurencesOfPropertyTypes);

		storeTotalIndividualCount(classesAndDatatypes);

		storeSubClassesCount(classesAndDatatypes);

		storeTypesCount(classesAndDatatypes);

		filteredNodes = classesAndDatatypes;
		filteredProperties = properties;
	};

	function resetStoredData() {
		nodeCount = 0;
		edgeCount = 0;
		classCount = 0;
		classes = [];
		externalClasses = [];
		equivalentsClassCount = 0; 
		equivalentsClasses=[];
		datatypeCount = 0;
		datatypes = [];
		datatypePropertyCount = 0;
		datatypeProperties = [];
		objectPropertyCount = 0;
		objectProperties = [];
		propertyCount = 0;
		totalIndividualCount = 0;
		totalSubClasses = 0;
		typesCount = [];
		externalNodeCount = 0;
		calcCount = [];
	}

	function storeTotalCounts(classesAndDatatypes, properties) {
		nodeCount = classesAndDatatypes.length;

		var seenProperties = require("../util/set")(), i, l, property;
		for (i = 0, l = properties.length; i < l; i++) {
			property = properties[i];
			if (!seenProperties.has(property)) {
				edgeCount += 1;
			}

			seenProperties.add(property);
			if (property.inverse()) {
				seenProperties.add(property.inverse());
			}
		}
	}

	function storeClassAndDatatypeCount(classesAndDatatypes) {
		// Each datatype should be counted just a single time
		var datatypeSet = d3.set(),
			hasThing = false,
			hasNothing = false;
        classCount=0;
				classes=[];
				externalClasses=[];
				equivalentsClassCount=0;
				equivalentsClasses=[];
				datatypes=[];
        var old=0,newcc=0;				
		classesAndDatatypes.forEach(function (node) {
			if (elementTools.isDatatype(node)) {
				datatypeSet.add(node.defaultLabel());
				datatypes.push(node.iri());
			} else if (!(node instanceof SetOperatorNode)) {
				if (node instanceof OwlThing) {
					hasThing = true;
				} else if (node instanceof OwlNothing) {
					hasNothing = true;
				} else {
					old=classCount;
					var adds= 1+countElementArray(node.equivalents());
					equivalentsClassCount += countElementArray(node.equivalents());
          classCount += adds;
					if (adds >1)
						node.equivalents().forEach(function (nodeE){
							equivalentsClasses.push(nodeE.iri());
					})
					newcc=classCount;
					if (Array.isArray(node.attributes()) && node.attributes().includes("external"))
						externalClasses.push(node.iri())
					else
						classes.push(node.iri())
				}
			} else if (node instanceof SetOperatorNode){
                old=classCount;
                classCount += 1;
								classes.push(node.iri())
                newcc=classCount;
			}
		});

		// count things and nothings just a single time
		// classCount += hasThing ? 1 : 0;
		// classCount += hasNothing ? 1 : 0;

		datatypeCount = datatypeSet.size();
		//console.log("statistics.js function storeClassAndDatatypeCount(classesAndDatatypes)", classes, equivalentsClasses, datatypes);
	}

	function storePropertyCount(properties) {
		for (var i = 0, l = properties.length; i < l; i++) {
			var property = properties[i];
            var attr;
            var result=false;
            if (property.attributes){
                attr=property.attributes();
                if (attr && attr.indexOf("datatype")!==-1){
                    result=true;
                }
            }
            if (result===true) {
                datatypePropertyCount += getExtendedPropertyCount(property);
								datatypeProperties.push(property.iri());
            }else if (elementTools.isObjectProperty(property)) {
                objectPropertyCount += getExtendedPropertyCount(property);
								objectProperties.push(property.iri());
			}
		}
		propertyCount = objectPropertyCount + datatypePropertyCount;
	}

	function getExtendedPropertyCount(property) {
		// count the property itself
		var count = 1;

		// and count properties this property represents
		count += countElementArray(property.equivalents());
		count += countElementArray(property.redundantProperties());

		return count;
	}

	function countElementArray(properties) {
		if (properties) {
			return properties.length;
		}
		return 0;
	}

	function storeOccurencesOfTypes(elements, storage) {
		elements.forEach(function (element) {
			var type = element.type(),
				typeCount = storage[type];

			if (typeof typeCount === "undefined") {
				typeCount = 0;
			} else {
				typeCount += 1;
			}
			storage[type] = typeCount;
		});
	}

	function storeTotalIndividualCount(nodes) {
		var sawIndividuals={};
		var totalCount = 0;
		for (var i = 0, l = nodes.length; i < l; i++) {
            var individuals = nodes[i].individuals();

            var tempCount = 0;
            for (var iA = 0; iA < individuals.length; iA++) {
                if (sawIndividuals[individuals[iA].iri()] === undefined) {
                    sawIndividuals[individuals[iA].iri()]=1; // this iri for that individual is now set to 1 >> seen it
                    tempCount++;
                }
            }
            totalCount += tempCount;
        }
		totalIndividualCount = totalCount;
		sawIndividuals={}; // clear the object

	}

	function storeSubClassesCount(nodes) {
		for (var i = 0, l = nodes.length; i < l; i++) {
      var ann = nodes[i].annotations();
			if (ann && Array.isArray(ann.subClassOf) && ann.subClassOf.length>0)
				totalSubClasses += 1;
		}
	};

	/** Формирует статистику по типам узлов */
	function storeTypesCount(nodes) {
		let types=[];
		for (var i = 0, l = nodes.length; i < l; i++) {
      var ann = nodes[i].annotations();
			if (nodes[i].attributes().includes("external"))
				externalNodeCount++
			// if (nodes[i].type().toLowerCase() == "externalclass")
			// 	externalNodeCount++
			//console.log("SPQRQLGraph.js function storeTypesCount(nodes)", ann)
			if (ann && Array.isArray(ann.type) && ann.type.length>0){
				ann.type.forEach(function (type) {
					if (type.value){
						if (typeof types[type.value] === 'undefined')
							types[type.value] = 0
						types[type.value] += 1 
					}
				})
			};
		};
		typesCount = types.sort();
		//console.log("SPQRQLGraph.js function storeTypesCount(nodes)", types)
	};
	
	statistics.nodeCount = function () {
		return nodeCount;
	};

	statistics.occurencesOfClassAndDatatypeTypes = function () {
		return occurencesOfClassAndDatatypeTypes;
	};

	statistics.edgeCount = function () {
		return edgeCount;
	};

	statistics.occurencesOfPropertyTypes = function () {
		return occurencesOfPropertyTypes;
	};

	statistics.classCount = function () {
		return classCount;
	};

	statistics.classCountAdv = function (i18n) {
		return ""+classCount
			+((externalClasses && externalClasses.length>0) 
			  ? (", "+(i18n?i18n.t('graph.statistic.nodeIncluding'):"including")+": "+(i18n?i18n.t('graph.statistic.external'):"external")+" - "+externalClasses.length)
				:""
			)
			+((equivalentsClasses && equivalentsClasses.length>0) 
				? (", "+(i18n?i18n.t('graph.statistic.equivalents'):"equivalents")+" - "+equivalentsClasses.length)
				:""
			);
	};

	statistics.classes = function () {
		return classes;
	};

	statistics.equivalentsClassCount = function () {
		return equivalentsClassCount;
	};

	statistics.datatypeCount = function () {
		return datatypeCount;
	};

	statistics.datatypes = function () {
		return datatypes;
	};
	

	statistics.datatypePropertyCount = function () {
		return datatypePropertyCount;
	};

	statistics.objectPropertyCount = function () {
		return objectPropertyCount;
	};

	statistics.propertyCount = function () {
		return propertyCount;
	};

	statistics.totalIndividualCount = function () {
		return totalIndividualCount;
	};


	// Functions a filter must have
	statistics.filteredNodes = function () {
		return filteredNodes;
	};

	statistics.filteredProperties = function () {
		return filteredProperties;
	};

	statistics.totalSubClasses = function () {
		return totalSubClasses;
	};

	statistics.typesCount = function (namespaces=[]) {
		//console.log("SPQRQLGraph.js statistics.typesCount = function ()", typesCount, Array.isArray(typesCount), namespaces)
		return (Array.isArray(typesCount)) 
			?
				Object.entries(typesCount)
					.map(([key, value]) => makeLabel(key, namespaces)+"="+value)
					.join(", ")
			:
			  ""
	};	

	/** Сохранение расчётной статистики или её получение */
	statistics.calcCount = function (p) {
		if (!arguments.length) return calcCount;
		calcCount = p
		return statistics;
	};


	/** Вычленить последнее значение в iri, для получения IRI-based */
	function makeLabel(iri, namespaces){
		if (iri){
			//Попробуем создать сокращённое имя
			if (Array.isArray(namespaces) && namespaces.length>0){
				for (let j = 0; j < namespaces.length; j++) {
					const namespace = namespaces[j];
					const keys = Object.keys(namespace)
					for (let i = 0; i < keys.length; i++) {
						if (iri.startsWith(namespace[keys[i]]))
						 return keys[i]+":"+iri.substring(namespace[keys[i]].length)
					}
					}
			}
			if (iri.lastIndexOf('#')>0) return iri.substring(iri.lastIndexOf('#')+1);
			if (iri.lastIndexOf('/')>0) return iri.substring(iri.lastIndexOf('/')+1);
		}
		return iri;
	}

	statistics.legendCount = function (totals=[], i18n) {		
		return i18n.t('graph.statistic.nodeDetails') +": " + (i18n?i18n.t('graph.statistic.externalElement'):"external element")+" - "
			+ externalNodeCount + ((Array.isArray(totals)) ? ", "+totals.join(", ") : "")
	};	

	/** Детальная статистика по узлам  */ 
	statistics.legendNodesCount = function (totals=[], i18n) {		
		return i18n.t('graph.statistic.nodeDetails') +": " + (i18n?i18n.t('graph.statistic.externalElement'):"external element")+" - "
			+ externalNodeCount + ((Array.isArray(totals)) ? ", "+totals.join(", ") : "")
	};	

	/** Детальная статистика по рёбрам  */ 
	statistics.legendEdgesCount = function (totals=[], i18n) {		
		if (Array.isArray(totals) && totals.length>0)
			return i18n.t('graph.statistic.nodeDetails')+ ": " +  ((Array.isArray(totals)) ? " "+totals.join(", ") : "");
		return "";
	};	

	statistics.debugContent = function () {
		return JSON.stringify({
			"classes": classes, 
			"externalClasses": externalClasses,
			"equivalentsClasses":equivalentsClasses,
			"datatypes": datatypes,
			"datatypeProperties": datatypeProperties,			
			"objectProperties": objectProperties
		})
	};	

	return statistics;
};
